import { styled } from '@zoopla-eng/zds-components/themes';

export const Container = styled('div', {
    height: '$L400',
    position: 'relative',
    display: 'flex',
    alignItems: 'center',
    px: '$S200',
    '@L100': {
        px: 0,
        height: '$L500'
    }
});

export const SkipToContent = styled('div', {
    '& a': {
        position: 'absolute',
        clipPath: 'inset(100%)',
        clip: 'rect(0 0 0 0)',

        '&:focus, &:active': {
            top: '$S300',
            left: '$S300',
            clip: 'auto',
            overflow: 'visible',
            clipPath: 'none'
        }
    }
});

export const Nav = styled('nav', {
    display: 'grid',
    gridTemplateAreas: "'headerleft headermiddle headerright'",
    gridTemplateColumns: 'auto 1fr auto',
    alignItems: 'center',
    width: '100%'
});

export const LinkList = styled('ul', {
    display: 'flex',
    listStyle: 'none',
    flexDirection: 'row',
    columnGap: '$S500',
    fontGroup: 'ladle',
    pt: '$S200' // this is a visual hack to make the links sit on the bottom of the logo
});

export const ActionList = styled('ul', {
    display: 'flex',
    listStyle: 'none',
    flexDirection: 'row',
    columnGap: '$S100',
    fontGroup: 'zester'
});

export const ActionListItem = styled('li', {
    position: 'relative',
    '.update-indicator': {
        position: 'absolute',
        top: 0,
        right: '2px'
    },
    // notificationCountExperiment - large variant icons sit too close to the icon
    '.update-indicator-large': {
        right: 0
    }
});

export const MenuItem = styled('li', {
    position: 'relative',
    '.update-indicator': {
        position: 'absolute',
        top: 0,
        right: '0',
        transform: 'translateX(100%)'
    }
});

export const DrawerList = styled('ul', {
    display: 'flex',
    flexDirection: 'column',
    listStyle: 'none',
    py: '$S400',
    px: '$S500',
    gap: '$M100',
    fontGroup: 'mug'
});
